export default __webpack_public_path__ + "static/media/938.b515a4f9.png";